(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ctm-gallery-media-item"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__ctmLazyVideoInit) return;
    window.__ctmLazyVideoInit = true;

    function loadVideo(video) {
      if (video.dataset.lazyLoaded) return;
      video.dataset.lazyLoaded = '1';
      var sources = video.querySelectorAll('source[data-src]');
      sources.forEach(function (s) {
        s.src = s.dataset.src;
        s.removeAttribute('data-src');
      });
      video.load();
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            loadVideo(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '200px 0px' }
    );

    function watch() {
      document.querySelectorAll('video[data-lazy-video]').forEach(function (v) {
        if (!v.__ctmObserved) {
          io.observe(v);
          v.__ctmObserved = true;
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', watch);
    } else {
      watch();
    }
    document.addEventListener('shopify:section:load', watch);
  })();
  } catch(e) { console.error(e); }
})();

})();
